module.exports = __webpack_public_path__ + "e4f290ce0cca316537a643da118dffb2.svg";